"use client";

import CarouselSection from "@/components/CarouselSection";
import { useTranslations } from "next-intl";

export default function CityPopularRoutesClient({ cityNeighbors }) {
  const t = useTranslations("flight");

  return (
    <CarouselSection
      title={t("nearbyOtherCities")}
      linkText={t("viewAll")}
      items={cityNeighbors}
      componentType="PopularLocationCard"
      componentProps={{}}
      showDots={false}
      loop={false}
      showTabs={false}
    />
  );
}
